module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2022_05.29dbff43.jpg";